import { useSearch } from "@tanstack/react-router";
import { CascadeCommissionsDrawer } from "components/Drawers/CascadeCommissionsDrawer/CascadeCommissionsDrawer";
import { PingtreeForm } from "components/Forms/PingtreeForm/PingtreeForm.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { useUser } from "hooks/useUser";
import { PermissionEnum, RoleEnum } from "types/enums";
import { DrawerId, FormId } from "types/models";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getOfferEditHeaderItems } from "utils/tenantHeaderItems.ts";

interface SearchParams {
    [`cascadeCommissions-id`]: string;
}

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/pingtree/"
)({
    component: OfferPingTreeEditPage,
    staticData: {
        permissions: [PermissionEnum.OfferEditCascade],
        showInSideMenu: false,
        label: "pages.offer.edit.pingtree.title",
    },
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.offer.edit.pingtree.title"),
    }),
});

function OfferPingTreeEditPage() {
    const { offerId } = Route.useParams();
    const userUtils = useUser();
    const { t: tE } = usePaldockTranslation("pages.offer.edit");
    const searchParams = useSearch({ strict: false }) as SearchParams;
    const cascadeFormId = FormId.CascadeForm;
    const cascadeCommissionsDrawerId = DrawerId.CascadeCommissions;

    return (
        <TenantPage
            headerNavigationItems={getOfferEditHeaderItems}
            saveFormId={
                userUtils
                    ?.getActiveTenant()
                    ?.userRoles?.some((role) => [RoleEnum.AdminFree, RoleEnum.AdminBeast].includes(role.name))
                    ? cascadeFormId
                    : null
            }
            detailLink={
                userUtils
                    ?.getActiveTenant()
                    ?.userRoles?.some((role) => [RoleEnum.AdminFree, RoleEnum.AdminBeast].includes(role.name))
                    ? {
                          to: "/offer/detail/$offerId/link",
                          params: { offerId: offerId },
                          label: tE("offer_preview"),
                      }
                    : null
            }
            isEdit={true}
        >
            <PingtreeForm key={offerId} offerId={offerId} />
            {searchParams[`${cascadeCommissionsDrawerId}-id`] && <CascadeCommissionsDrawer />}
        </TenantPage>
    );
}
